import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Popover from '@material-ui/core/Popover'
import EventIcon from 'components/material-symbol/icons/Event'
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers'
import { ThemeProvider } from '@mui/material/styles'
import CustomLuxonAdapter from 'lib/CustomLuxonAdapter'
import { formatToolbarDateLabel } from './calendar-utils'
import { calendarDatePickerTheme } from './calendar-date-picker-theme'
import {
  calendarDateCalendarSlots,
  calendarDateCalendarSlotProps,
} from './calendar-date-calendar-slots'
import useCalendarStyles from './calendar-styles'

const CalendarDatePicker = ({ anchorDate, onDateChange }) => {
  const classes = useCalendarStyles()
  const [pickerAnchor, setPickerAnchor] = useState(null)

  const handleChange = date => {
    if (date) {
      onDateChange(date)
      setPickerAnchor(null)
    }
  }

  return (
    <>
      <Button
        variant="outlined"
        className={classes.datePickerButton}
        startIcon={<EventIcon fontSize="small" />}
        onClick={event => setPickerAnchor(event.currentTarget)}
        aria-label="Choose date"
        aria-haspopup="dialog"
        aria-expanded={Boolean(pickerAnchor)}
      >
        {formatToolbarDateLabel(anchorDate)}
      </Button>
      <Popover
        open={Boolean(pickerAnchor)}
        anchorEl={pickerAnchor}
        onClose={() => setPickerAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        classes={{ paper: classes.datePickerPopover }}
      >
        <ThemeProvider theme={calendarDatePickerTheme}>
          <LocalizationProvider dateAdapter={CustomLuxonAdapter} locale="en-us">
            <DateCalendar
              value={anchorDate}
              onChange={handleChange}
              dayOfWeekFormatter={day => `${day}`}
              className={classes.dateCalendar}
              slots={calendarDateCalendarSlots}
              slotProps={calendarDateCalendarSlotProps}
            />
          </LocalizationProvider>
        </ThemeProvider>
      </Popover>
    </>
  )
}

CalendarDatePicker.propTypes = {
  anchorDate: PropTypes.object.isRequired,
  onDateChange: PropTypes.func.isRequired,
}

export default CalendarDatePicker
